import { Link } from "@/lib/navigation";
import AppImage from "@/components/AppImage";
import styles from "./Footer.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.section}>
          <h3>About Us</h3>
          <Link to="/about">About</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/roadmap">Product Roadmap</Link>
        </div>

        <div className={styles.section}>
          <h3>Legal</h3>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/dpa">Data Processing Agreement</Link>
          <Link to="/security-policy">Security Policy</Link>
        </div>

        <div className={styles.section}>
          <h3>Connect</h3>
          <a
            href="https://uk.bookshop.org/shop/novelnet"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bookshop.org
          </a>
          <a
            href="https://www.instagram.com/novelnet.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          <a
            href="https://www.tiktok.com/@novelnet.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            TikTok
          </a>
          <a
            href="https://www.linkedin.com/company/novel-net/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
          <a
            href="https://bsky.app/profile/novelnet.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            BlueSky
          </a>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.badge}>
          <AppImage
            src="/Developed By Human/_SVG/Developed-By-Humans-Not-By-AI-Badge-black.svg"
            alt="Developed by humans, not by AI"
            width={150}
            height={50}
            priority={false}
          />
        </div>
        <p>&copy; {currentYear} NovelNet. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
